// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__yccQz","content":"Consent_content__2Ybom","footer":"Consent_footer__3wgqM"};